// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const TextareaContract = contract({
  name: "Textarea",
  description: "Multi-line text entry (descriptions, messages, comments). Pair with a Label. Single-line input → use Input instead. Use size=\"sm\"/\"xs\" in dense tool panels.",
  import: "@gradeui/ui",
  aliases: ["text area","multiline","comment box","message field","text editor","multi-line text","multiline input","multiline text field","comments box","multiline textinput"],
  element: "textarea",
  composesWith: ["Label","Form","Card (in CardContent)"],
  styleDefaults: {"Textarea":"flex w-full rounded-md border border-input bg-background dark:bg-input/30 placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 min-h-[80px] px-3 py-2 text-sm"},
  variantDefaults: {"size":"default"},
  props: {
  "size": {
      schema: z.enum(["default", "sm", "xs"]).optional(),
      design: "knob",
      description: "control density, mirrors Input. default = min-h-80 / text-sm; sm and xs shrink the min-height + padding for dense panels.",
  },
  },
});
